export default "__VITE_ASSET__FDCryIGa__"